import React, { useContext, useRef, useState } from 'react';
import SectionHeader from '@nile/reports/src/modules/EfficiencyReport/components/subpages/SectionHeader';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';
import RenderSuperChart from './RenderSuperChart';

function SuperChart({ advancedChart = {}, client = null }) {
  const { name, description, chart = [], filter } = advancedChart;
  const reportsContext = useContext(ReportsContext);

  const [category, setCategory] = useState(filter?.value || null);

  const categoryRef = useRef({});
  categoryRef.current = category;

  return (
    <div className="flex fcol full-width">
      <div className="mb40">
        <div className="divider" />
      </div>
      <div className="flex fcol full-width">
        <SectionHeader
          hideIcon
          name={name}
          description={description}
          action={{ ...filter, value: category, setValue: setCategory }}
        />
        <div className="mt10">
          {chart?.map((el) => (
            <div className="mbt10">
              <SectionHeader size="h3" hideIcon name={el?.name} />
              <div className="mt8">
                <RenderSuperChart
                  {...el}
                  reportsContext={reportsContext}
                  selectedClient={client}
                  condition={categoryRef.current}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SuperChart;
